import React, { RefObject } from 'react';

const TableBuilderAgGridChartView = ({
  chartWrapperRef,
  showChartView,
}: {
  chartWrapperRef: RefObject<HTMLDivElement | null>;
  showChartView: boolean;
}) => {
  return showChartView ? (
    <div
      ref={chartWrapperRef}
      id="tableChart"
      data-testid="tableChartView"
      className="ag-theme-quartz height-maximum pb5 screenshotSizeToContent"
    />
  ) : null;
};

export default TableBuilderAgGridChartView;
